module.exports = "/photo/dist/./assets/images/ZEISS_Brand_CMYK.svg";


//////////////////
// WEBPACK FOOTER
// ./frontend/assets/images/ZEISS_Brand_CMYK.svg
// module id = 231
// module chunks = 0